<div class="mx-1 mt-3 mb-0 p-4 rounded-lg shadow-md overflow-y-auto relative">
  <div
    class="absolute inset-0 bg-[url('/title_bg_light.jpg')] dark:bg-[url('/title_bg_dark.jpg')] bg-cover bg-center bg-no-repeat opacity-50 dark:opacity-50"
  ></div>
  <div class="relative z-10">
    <div class="flex gap-3 mt-2">
      <div class="w-full">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="block text-xs text-gray-200 dark:text-gray-200">&nbsp;</label>
        <div class="text-2xl text-gray-900 dark:text-gray-100">Welcome to Summa Cloud</div>
      </div>
    </div>

    <div class="flex gap-3 mt-0">
      <div class="w-full mb-4">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="block text-xs text-gray-900 dark:text-gray-100"
          >Clinical study management made easy.</label
        >
      </div>
    </div>
  </div>
</div>
